import { SampleDataSaturationModel } from '../../../models/sample-data-saturation-model';
import { Chart } from 'angular-highcharts';
import { JobReturnCache } from '../../../models/job-return-cache.model';

export class AnnotationEditObject {
	comment?: string;
	delete?: boolean;
}

export class ChannelSettingsModel {
	// Subset of UnitPeriodChannelDto (derived from).
	id: number;
	label: string;
	showGraph: boolean;
	minY: number;
	maxY: number;
	colorHex: string;
	lineWeight = 1;
	units: string;
	parent: boolean;
	combined: boolean;
	linkedTo: number;
	isDisabled: boolean = false;
	uiIndex?: number;
	unitName: string;
	unitNameHtml?: string;
	unitDescription?: string;
}

export class ChartSettingsModel {
	jobId: number;
	title: string;
	channelSettings: ChannelSettingsModel[];
	combineUnits: boolean;
	sampleDataSaturation?: SampleDataSaturationModel;
}

export interface JobDataPointsTotals {
	jobTotalPoints: number;
	enabledChannelsTotalPoints: number;
}

export interface ChartSettingsModalModel {
	chartSettings: ChartSettingsModel;
	chart: Chart;
	unitPeriods: JobReturnCache[];
}
